export default {
    'zh_CN': {
        send: '发送',
        pleasecomplete: '请填写完整！',
        pleasewait: '请稍等',
        app_info_3: '详情',
        app_info_4: '评论',
        app_info_5: '撰写评论',
        app_info_6: '轻点星形来评分',
        app_info_7: '评分',
        app_info_8: '您尚未登录，请先登录',
        app_info_14: '登录/注册',
        app_info_36: '游戏简介',
        app_info_37: '信息',
        app_info_74: '分',
        app_info_75: '个评分',
        app_info_76: '轻点星形来评分',
        app_info_102: '提交成功，需要审核通过才能看到哦！',
        app_info_153: '标题',
        version: '版本',
        size: '大小',
        price: '资费',
        language: '语言',
        no_comment_yet: '暂无评论',
        validationErrors: '错误',
        more: '更多',
        can_not_be_empty: '不能为空',
        sensitive_words: '评论包含敏感词!',
        enter_correct_content: '请输入正确的文字内容!',
    },
    'en_US': {
        send: 'send',
        pleasecomplete: 'Please complete!',
        pleasewait: 'Please wait',
        app_info_3: 'Detail',
        app_info_4: 'Reviews',
        app_info_5: 'Write a review',
        app_info_6: 'Press the stars to rate',
        app_info_7: 'rating',
        app_info_8: 'You are not signed in. Pease sign in first.',
        app_info_14: 'Sign in/Register',
        app_info_36: 'Overview',
        app_info_37: 'Info',
        app_info_74: 'Ratings',
        app_info_75: 'Ratings',
        app_info_76: 'Tap the star to rate',
        app_info_102: 'Upon submitting a review: We have received your review. It will be published soon if it complies with local laws and regulations.！',
        app_info_153: 'title',
        version: 'Version',
        size: 'Size',
        price: 'Price',
        language: 'Language',
        no_comment_yet: 'no comment yet',
        validationErrors: 'Error',
        more: 'More',
        can_not_be_empty: 'Can not be empty',
        sensitive_words: 'Comments contain sensitive words!',
        enter_correct_content: 'Please enter the correct text content',
    },
    'ja_JP': {
        send: '送信',
        pleasecomplete: 'してください!',
        pleasewait: 'しばらくお待ちください',
        app_info_3: '詳細',
        app_info_4: 'レビュー',
        app_info_5: 'レビューを書く',
        app_info_6: '星をタップして評価してください',
        app_info_7: '評価',
        app_info_8: 'ログインしてください',
        app_info_14: 'ログイン/登録',
        app_info_36: 'ゲーム説明',
        app_info_37: '情報',
        app_info_74: '点数',
        app_info_75: '評価',
        app_info_76: '星をタップして評価してください',
        app_info_102: '送信できました。審査を通った後反映されます',
        app_info_153: 'タイトル',
        version: 'バージョン',
        size: 'サイズ',
        price: '価格',
        language: '言語',
        no_comment_yet: 'コメントはまだありません',
        validationErrors: 'エラー',
        more: 'もっと',
        can_not_be_empty: '空ではありません',
        sensitive_words: 'コメントには機密情報が含まれています',
        enter_correct_content: '正しいテキストコンテンツを入力してください',
    }
};